import { get, post } from "./http";

export const GetGeneFunctionsApi = (params) =>
  post("/public/geneResearch/functions", params, { skipLoading: true, skipError: true });

export const GetGeneRelationshipsApi = (params) =>
  post("/public/geneResearch/relationships", params, { skipLoading: true, skipError: true });

/**
 * 登录
 */
export const PostUserLoginApi = (param) => post("/public/login", param);

/**
 * 获取验证码
 */
export const GetCaptcha = () =>
  post("/api/code/public/captch/code", {
    height: 30,
    width: 100,
  });

/**
 * 找回密码
 */
export const PostUserForgetPasswordApi = (param) =>
  post("/public/findPwd", param);

/**
 * 修改密码
 */
export const PostUserChangePasswordApi = (param) =>
  post("/public/rePwd", param);

/**
 * 邮箱验证码
 */
export const PostUserEmailCodeApi = (param) =>
  post("/api/code/public/email", param);
/**
 * 邮箱验证码
 */
export const PostUserPhoneCodeApi = (param) =>
  post("/api/code/public/sms", param);

/**
 * 注册
 */
export const PostUserRegisterApi = (param) => post("/public/register", param);

/**
 * 获取个人信息
 */
export const GetUserInfoApi = () => post("/public/userInfo", {});

/**
 * 修改个人信息
 */
export const PostUserInfoApi = (param) => post("/public/updateUserInfo", param);


/**
 * 调用访问数接口
 */
export const getVisitCountApi = () =>
  post("/public/second/addTraffic", {}, { skipError: true });

/**
 * 获取首页轮播图
 */
export const GetIndexBannerApi = () => post("/public/second/listBanner", {});

/**
 * 获取友链
 */
export const GetFriendLinkApi = (obj) => post("/public/second/listLink", obj);

/**
 * 获取访问量
 */
export const GetVisitCountApi = () => post("/public/second/trafficCount", {});
/**
 * 获取年报列表
 */
export const GetYearReportListApi = (obj) =>
  post("/public/second/listYearReport", obj);
/**
 * 获取资质公开列表
 */
export const GetQualificationDisclosureListApi = (obj) =>
  post("/public/second/listQualificationDisclosure", obj);

/**
 * 获取主题资源
 */
export const GetThemeResourceApi = (obj) =>
  post("/public/second/listTheme", obj);

/**
 * 获取主题详情
 */
export const GetThemeDetailApi = (obj) =>
  post("/public/second/detailTheme", obj);

/**
 * 查询文章列表分页
 */
export const GetArticleListApi = (obj) =>
  post("/public/second/pageArticle", obj);
/**
 * 查询文章列表不分页
 */
export const GetArticleListApiNoPage = (obj) =>
  post("/public/second/listArticle", obj);

/**
 * 获取文章详情
 */
export const GetArticleDetailApi = (obj) =>
  post("/public/second/detailArticle", obj);

/**
 * 加入购物车
 */
export const GetAddCartApi = (obj) =>
  post("/public/second/addCart", obj);
/**
 * 删除购物车
 */
export const DelCartApi = (obj) =>
  post("/public/second/delCart", obj);
/**
 * 获取购物车列表
 */
export const GetCartListApi = (obj) =>
  post("/public/second/listCart", obj);
/**
 * 购物车下单
 */
export const CartAddOrderApi = (obj) =>
  post("/public/second/addOrder", obj);

/**
 * 获取数据汇交字段
 */
export const GetDataExchangeApi = (obj) =>
  post("/public/second/dataSubmissionList", obj);

/**
 * 提交数据汇交
 */
export const PostDataExchangeApi = (obj) =>
  post("/public/second/createDataSubmission", obj);
/**
 * 查询数据汇交分页
 */
export const PostDataSubmissionListApi = (obj) =>
  post("/public/second/pageDataSubmission", obj);
/**
 * 查询数据汇交详情
 */
export const PostDataSubmissionDetailApi = (obj) =>
  post("/public/second/detailDataSubmission", obj);
/**
 * 撤回数据汇交
 */
export const PostWithdrawApi = (obj) =>
  post("/public/second/revokeDataSubmission", obj);

/**
 * 获取基因列表
 */
export const GetGeneListApi = (obj) =>
  post("/public/search", obj, { skipError: true });

/**
 * 获取基因详情
 */
export const GetGeneDetailApi = (obj) =>
  post("/public/detailList", obj);

/**
 * 获取表型列表
 */
export const GetPhenotypeListApi = (obj) =>
  post("/public/phenotypicList", obj);
/**
 * 退出登录
 */
export const logout = (obj) =>
  post("/public/logout", obj);

/**
 * 提交咨询
 */
export const PostConsultationCreateApi = (obj) =>
  post("/public/consultation/create", obj);

/**
 * 查询我的咨询列表
 */
export const PostConsultationPageApi = (obj) =>
  post("/public/consultation/page", obj);

/**
 * 查询我的咨询详情
 */
export const PostConsultationDetailApi = (obj) =>
  post("/public/consultation/detail", obj);
